// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Private Endpoint Service API
 * private-endpoint-service-api manages Private Endpoint Services in ingress clusters
 *
 * The version of the OpenAPI document: 1.0
 * Contact: team-aura-networking@neotechnology.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RegionalIngressState } from './RegionalIngressState';
import {
  RegionalIngressStateFromJSON,
  RegionalIngressStateFromJSONTyped,
  RegionalIngressStateToJSON,
  RegionalIngressStateToJSONTyped,
} from './RegionalIngressState';
import type { InstanceTrafficPolicyDetail } from './InstanceTrafficPolicyDetail';
import {
  InstanceTrafficPolicyDetailFromJSON,
  InstanceTrafficPolicyDetailFromJSONTyped,
  InstanceTrafficPolicyDetailToJSON,
  InstanceTrafficPolicyDetailToJSONTyped,
} from './InstanceTrafficPolicyDetail';
import type { CustomerEnvironmentState } from './CustomerEnvironmentState';
import {
  CustomerEnvironmentStateFromJSON,
  CustomerEnvironmentStateFromJSONTyped,
  CustomerEnvironmentStateToJSON,
  CustomerEnvironmentStateToJSONTyped,
} from './CustomerEnvironmentState';
import type { OrchestraState } from './OrchestraState';
import {
  OrchestraStateFromJSON,
  OrchestraStateFromJSONTyped,
  OrchestraStateToJSON,
  OrchestraStateToJSONTyped,
} from './OrchestraState';

/**
 *
 * @export
 * @interface EndToEndState
 */
export interface EndToEndState {
  /**
   *
   * @type {CustomerEnvironmentState}
   * @memberof EndToEndState
   */
  customerEnvironment?: CustomerEnvironmentState;
  /**
   *
   * @type {RegionalIngressState}
   * @memberof EndToEndState
   */
  regionalIngress?: RegionalIngressState;
  /**
   * Per-orchestra cluster state, keyed by cluster name.
   * @type {{ [key: string]: OrchestraState; }}
   * @memberof EndToEndState
   */
  orchestras?: { [key: string]: OrchestraState };
  /**
   * Per-instance traffic policy state, including last-applied detail.
   * @type {Array<InstanceTrafficPolicyDetail>}
   * @memberof EndToEndState
   */
  instancePolicies?: Array<InstanceTrafficPolicyDetail>;
}

/**
 * Check if a given object implements the EndToEndState interface.
 */
export function instanceOfEndToEndState(value: object): value is EndToEndState {
  return true;
}

export function EndToEndStateFromJSON(json: any): EndToEndState {
  return EndToEndStateFromJSONTyped(json, false);
}

export function EndToEndStateFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): EndToEndState {
  if (json == null) {
    return json;
  }
  return {
    customerEnvironment:
      json['customer_environment'] == null
        ? undefined
        : CustomerEnvironmentStateFromJSON(json['customer_environment']),
    regionalIngress:
      json['regional_ingress'] == null
        ? undefined
        : RegionalIngressStateFromJSON(json['regional_ingress']),
    orchestras:
      json['orchestras'] == null
        ? undefined
        : mapValues(json['orchestras'], OrchestraStateFromJSON),
    instancePolicies:
      json['instance_policies'] == null
        ? undefined
        : (json['instance_policies'] as Array<any>).map(
            InstanceTrafficPolicyDetailFromJSON,
          ),
  };
}

export function EndToEndStateToJSON(json: any): EndToEndState {
  return EndToEndStateToJSONTyped(json, false);
}

export function EndToEndStateToJSONTyped(
  value?: EndToEndState | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    customer_environment: CustomerEnvironmentStateToJSON(
      value['customerEnvironment'],
    ),
    regional_ingress: RegionalIngressStateToJSON(value['regionalIngress']),
    orchestras:
      value['orchestras'] == null
        ? undefined
        : mapValues(value['orchestras'], OrchestraStateToJSON),
    instance_policies:
      value['instancePolicies'] == null
        ? undefined
        : (value['instancePolicies'] as Array<any>).map(
            InstanceTrafficPolicyDetailToJSON,
          ),
  };
}
